// system
export const FIELD_TYPE_FULL_NAME = 1;
export const FIELD_TYPE_PHOTO = 2;
export const FIELD_TYPE_BIRTHDAY = 3;
export const FIELD_TYPE_GENDER = 4;
export const FIELD_TYPE_PHONE = 5;
export const FIELD_TYPE_EMAIL = 6;
export const FIELD_TYPE_CITIZENSHIP = 7;
export const FIELD_TYPE_SKILLS = 8;
export const FIELD_TYPE_EDUCATION = 9;
export const FIELD_TYPE_CAREER = 10;
export const FIELD_TYPE_PORTFOLIO = 11;
export const FIELD_TYPE_ADDITIONAL_PHONE = 12;
export const FIELD_TYPE_WAY_TO_WORK = 13;
export const FIELD_TYPE_COVID = 14;
export const FIELD_TYPE_TRAVELING_WORK = 15;
export const FIELD_TYPE_ADDITIONAL_EDUCATION = 16;
export const FIELD_TYPE_SOCIALS = 17;
export const FIELD_TYPE_COMMENT = 18;
export const FIELD_TYPE_RESIDENTIAL_ADDRESS = 19;
export const FIELD_TYPE_METRO = 20;
export const FIELD_TYPE_REGISTRATION_ADDRESS = 21;
export const FIELD_TYPE_PERSONAL_DATA = 22;
export const FIELD_TYPE_AUTO = 23;
export const FIELD_TYPE_DESIRED_POSITION = 24;
export const FIELD_TYPE_VACANCY_SOURCE = 25;
export const FIELD_TYPE_FRIENDS_IN_COMPANY = 26;
export const FIELD_TYPE_RECENT_JOBS = 27;
export const FIELD_TYPE_EXPERIENCE = 28;
export const FIELD_TYPE_PASSPORT = 29;
export const FIELD_TYPE_DOCUMENTS = 30;

export const SYSTEM_TYPES = {
    [FIELD_TYPE_FULL_NAME]: { id: "full-name", name: "ФИО", isSystem: true, requiredByDefault: true },
    [FIELD_TYPE_PHOTO]: { id: "photo", name: "Фотография", isSystem: true },
    [FIELD_TYPE_BIRTHDAY]: { id: "birthday", name: "Дата рождения", isSystem: true },
    [FIELD_TYPE_GENDER]: { id: "gender", name: "Пол", isSystem: true },
    [FIELD_TYPE_PHONE]: { id: "phone", name: "Телефон", isSystem: true },
    [FIELD_TYPE_EMAIL]: { id: "email", name: "Email", isSystem: true },
    [FIELD_TYPE_CITIZENSHIP]: {
        id: "citizenship",
        name: "Гражданство",
        isSystem: true,
        hasDictionary: true,
        dictionaryCode: "citizenship",
        isList: true,
    },
    [FIELD_TYPE_SKILLS]: {
        id: "skills",
        name: "Навыки",
        isSystem: true,
        dictionaryCodes: {
            programs: "program",
            programLevels: "program_level",
            languages: "language",
            languageLevels: "language_level",
        },
        isComplex: true,
    },
    [FIELD_TYPE_EDUCATION]: { name: "Образование", isSystem: true },
    [FIELD_TYPE_CAREER]: {
        id: "career",
        name: "Карьера",
        isSystem: true,
        dictionaryCodes: {
            schedule: "shedule",
        },
        isComplex: true,
    },
    [FIELD_TYPE_PORTFOLIO]: { id: "portfolio", name: "Портфолио", isSystem: true },
    [FIELD_TYPE_ADDITIONAL_PHONE]: {
        id: "additional-phone",
        name: "Дополнительный номер телефона (родственника, знакомого)",
        isSystem: true,
        hasDictionary: true,
        dictionaryCode: "who_is",
        isList: true,
    },
    [FIELD_TYPE_WAY_TO_WORK]: {
        id: "way-to-work",
        name: "Сколько готовы тратить времени на дорогу до работы",
        isSystem: true,
        hasDictionary: true,
        dictionaryCode: "work_road_time",
        isList: true,
    },
    [FIELD_TYPE_COVID]: { id: "covid", name: "Наличие вакцины от COVID-19", isSystem: true, isBoolean: true },
    [FIELD_TYPE_TRAVELING_WORK]: {
        id: "travelling-work",
        name: "Готовность к разъездному характеру работы",
        isSystem: true,
        isBoolean: true,
    },
    [FIELD_TYPE_ADDITIONAL_EDUCATION]: {
        id: "additional-education",
        name: "Дополнительное образование (курсы, тренинги, повышение квалификации)",
        isSystem: true,
        optional: true,
    },
    [FIELD_TYPE_SOCIALS]: { id: "socials", name: "Соцсети", isSystem: true, optional: true },
    [FIELD_TYPE_COMMENT]: { id: "comment", name: "Комментарий", isSystem: true },
    [FIELD_TYPE_RESIDENTIAL_ADDRESS]: {
        id: "residential-address",
        name: "Фактический адрес проживания",
        isSystem: true,
    },
    [FIELD_TYPE_METRO]: {
        id: "metro",
        name: "Ближайшая станция метро",
        isSystem: true,
        hasDictionary: true,
        dictionaryCode: "metro",
        isList: true,
    },
    [FIELD_TYPE_REGISTRATION_ADDRESS]: { id: "registration-address", name: "Адрес регистрации", isSystem: true },
    [FIELD_TYPE_PERSONAL_DATA]: {
        id: "personal-data",
        name: "Персональная информация",
        isSystem: true,
        dictionaryCodes: {
            familyStatuses: "family_status",
        },
        isFull: true,
        isComplex: true,
    },
    [FIELD_TYPE_AUTO]: { id: "auto", name: "Наличие автомобиля", isSystem: true, optional: true },
    [FIELD_TYPE_DESIRED_POSITION]: {
        id: "desired-position",
        name: "Желаемая должность",
        isSystem: true,
        hasDictionary: true,
        dictionaryCode: "wish_post",
        isList: true,
    },
    [FIELD_TYPE_VACANCY_SOURCE]: {
        id: "vacancy-source",
        name: "Откуда вы узнали о вакансии",
        isSystem: true,
        hasDictionary: true,
        dictionaryCode: "source",
        isList: true,
    },
    [FIELD_TYPE_FRIENDS_IN_COMPANY]: {
        id: "friends-in-company",
        name: "Есть знакомые, работающие в компании",
        isSystem: true,
        optional: true,
    },
    [FIELD_TYPE_RECENT_JOBS]: {
        id: "recent-jobs",
        name: "Последние места работы",
        isSystem: true,
        hasDictionary: true,
        dictionaryCode: "last_job_post",
        isList: true,
    },
    [FIELD_TYPE_EXPERIENCE]: { id: "experience", name: "Опыт работы в сфере", isSystem: true, optional: true },
    [FIELD_TYPE_PASSPORT]: { id: "passport", name: "Паспортные данные", isSystem: true },
    [FIELD_TYPE_DOCUMENTS]: { id: "documents", name: "Документы", isSystem: true },
};

export const SYSTEM_TYPES_LIST = Object.entries(SYSTEM_TYPES).map(([key, value]) => ({
    value: +key,
    label: value.name,
}));
